/* @flow */

import * as React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import { connect } from 'react-redux';
import chatPathSelector from 'app/selectors/chat/chatPathSelector';
import chatChannelsSelector from 'app/selectors/chat/chatChannelsSelector';
import ChatMinimised from 'app/components/chat/ChatMinimised';
import Chat from 'app/components/chat/Chat';
import colorUtils from 'color';

type Props = {
  chatPath?: string,
  classes: Object,
  currentChannel?: ChatChannel
};

const defaultProps = {
  chatPath: undefined,
  currentChannel: undefined
};

function DesktopChat(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { classes, currentChannel, chatPath } = props;

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classes.chat}>
      <div className={classNames(classes.chatContainer, { isOpen })}>
        {isOpen ? (
          <Chat onHeaderClick={toggleChat}>
            <iframe className={classes.chatIFrame} src={chatPath} title="chat dialog" />
          </Chat>
        ) : (
          <ChatMinimised currentChannel={currentChannel} onHeaderClick={toggleChat} />
        )}
      </div>
    </div>
  );
}

DesktopChat.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    chat: {
      position: 'fixed',
      right: 0,
      zIndex: theme.zIndex.chat,
      bottom: 0
    },
    chatIFrame: {
      border: 0,
      display: 'block',
      maxHeight: '90vh',
      overflow: 'hidden',
      flexGrow: 1,
      width: '100%'
    },
    chatContainer: {
      width: 70,
      height: 50,
      boxShadow: `0 -1px 8px 0px ${colorUtils(theme.color.basis2)
        .alpha(0.3)
        .toString()}`,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.25s, width 0.25s ease-in-out 0.25s, height 0.25s ease-in-out',
      [theme.mediaQuery.desktopLargeOnly]: {
        width: '12vw',
        height: 30,
        borderBottomLeftRadius: 0
      },
      '&.isOpen': {
        width: 360,
        height: 580,
        transition: 'all 0.25s, width 0.25s ease-in-out, height 0.25s ease-in-out 0.25s',
        [theme.mediaQuery.desktopLargeOnly]: {
          width: 360,
          height: 580
        }
      }
    }
  };
}

function mapStateToProps(state: GlobalState) {
  const channels = chatChannelsSelector(state);
  return {
    chatPath: chatPathSelector(state),
    currentChannel: channels.find(channel => channel.id === state.chat.channelId)
  };
}

export default connect(mapStateToProps)(useSheet(applyStyles)(DesktopChat));
